import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogValiderCollab from '../../../Components/Dialogs/DialogValiderCollab';
import { StatutCollabClient } from '../../../data/Interfaces';

export function ColorBackgroundComponent(statut) {
    if (statut == 'actif')
        return '#BCE7CB';
    if (statut == 'enAttente')
        return '#fef3e1';
    if (statut == 'aValider')
        return '#dbdff5';
}

const ChangeStatutCollaborateur = ({ defaultStatusCollab, rowSelected, width, mode, getMyCollaborators }) => {

    ChangeStatutCollaborateur.propTypes = {
        rowSelected: PropTypes.any,
        width: PropTypes.any,
        defaultStatusCollab: PropTypes.any,
        mode: PropTypes.any,
        getMyCollaborators: PropTypes.func,
    };
    const [updatedRowData, setUpdatedRowData] = useState(null);
    const { i18n } = useTranslation();
    //const [defaultStatusCandidat,setDefaultStatusCandidat]=useState();
    const [statusCollaborateur, setstatusCollaborateur] = useState(rowSelected);
    const [openNestedRejetCollab, setOpenNestedRejetCollab] = useState(false);
    useEffect(() => {
        if (rowSelected) {
            console.log('is not vide', rowSelected);
            setstatusCollaborateur(rowSelected);
        }
    }, [rowSelected]);

    //setstatusCollaborateur(defaultStatusCollab);
    //useEffect(() => {
    //    if (defaultStatusCollab) {
    //        //console.log('default', defaultStatusCollab);
    //        setstatusCollaborateur(defaultStatusCollab);
    //    }
    //}, [defaultStatusCollab]);

    //const handleChangeStatus = (e) => {
    //    const newStatus = e.target.value;
    //    setstatusCollaborateur(e.target.value);
    //};

    const disabledSelect = () => {
        //on peut pas modifier le statut d'un collab si on a pas le mode edit
        // mm dans le mode edit on pourra pas modifier le statut actif et le statut en attente
        //console.log('defaultStatusCollab', defaultStatusCollab);
        if ((mode == 'edit' && (defaultStatusCollab == 'actif' || defaultStatusCollab == 'enAttente')) || mode != 'edit') {
            return true;
        }
        else
            return false;
    };

    return (
        <FormControl
            //sx={{ m: 1, width: 200, }}
            variant="outlined"
            style={{ width: width }}
            size='small'
        >
            <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                input={<OutlinedInput />}
                //defaultValue={defaultStatusCollab}
                value={statusCollaborateur?.statut}
                disabled={disabledSelect() == true ? true : false}
                onChange={(e) => {
                    let a = statusCollaborateur;
                    a.statut = e.target.value;
                    setstatusCollaborateur(a);
                    setUpdatedRowData(a);
                    setOpenNestedRejetCollab(true);
                }}
                style={{ backgroundColor: ColorBackgroundComponent(statusCollaborateur?.statut), width: width }}
            >
                {StatutCollabClient.map((option, i) => {
                    return (
                        //j'ai masqué le statut enAttente prcq l'admin pourra pas changer le statut d'un collab vers en attente
                        <MenuItem
                            style={{ width: width }}
                            key={i}
                            hidden={option?.value == 'enAttente' ? true : false}
                            value={option.value}
                        >
                            {i18n.t(option?.label)}
                        </MenuItem>
                    );
                })}
            </Select>
            {openNestedRejetCollab &&
                <DialogValiderCollab
                    open={openNestedRejetCollab}
                    setOpen={() => {
                        setOpenNestedRejetCollab(false);
                    }}
                    getMyCollaborators={getMyCollaborators}
                    title={i18n.t('Valider le collaborateur')}
                    rowSelected={updatedRowData || statusCollaborateur}
                    mode={'editer'}
                />}
        </FormControl>);
};

export default ChangeStatutCollaborateur;